import request from '@/utils/http';
import store from '@/store/index';

const supplierCode = store.state.supplier.supplierCode;
// 通知公告
export const getTenderList = (noticeType) => {
    return request({
        url: `/api-bms-web/bid/portal/querySupplierNoticeManagerPage`,
        method: 'POST',
        data: {
            pageSize: 5,
            supplierCode: supplierCode,
            noticeType: noticeType
        }
    });
};

// 月度累计及时率
export const getQuotas = (carrierCode) => {
    return request({
        url: `/api-tms/indicator/indicators`,
        method: 'GET',
        params: {
            carrierCode: carrierCode
        }
    });
};

// 财务待办
export const getBmsInfo = () => {
    return request({
        url: `/api-bms-web/bmsExternalCall/numberToDo`,
        method: 'GET'
    });
};

// 往来代办
export const getStatementInfo = (params) => {
    return request({
        url: `/api-bms-web/efApDealingsBill/getApDealingsBillList`,
        method: 'POST',
        data: params
    });
};

// 城配待办
export const getOtpInfo = (params) => {
    return request({
        url: `/api-tms/indicator/count`,
        method: 'GET',
        params: params
    });
};

// 大物流待办
export const getTmsInfo = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/backlog`,
        method: 'POST',
        data: params
    });
};

export const getList = {
    post(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/saveOrUpdate',
            method: 'post',
            data: params
        });
    },
    get(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/param',
            method: 'post',
            data: params
        });
    }
};

// 通知函数据确认不再显示接口
export const batchIssueTask = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/batchIssueTask`,
        method: 'POST',
        data: params
    });
};

// 通知函数据显示接口
export const rectificationTaskNotification = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/notification`,
        method: 'POST',
        data: params
    });
};

// 日常考核待办
export const queryDailyAssessmentsCount = (data) => {
    return request({
        url: `/api-srm-web/performance/portal/queryDailyAssessmentsCount/${data}`,
        method: 'GET'
    });
};

// 待提交整改任务
export const workbenchTasksManagerPage = (params) => {
    return request({
        url: `/api-srm-web/performance/portal/workbenchTasksManagerPage`,
        method: 'POST',
        data: params
    });
};

// 投标数据统计接口
export const getTenderInfo = (supplierCode) => {
    return request({
        url: `/api-srm-web/bid/bidSupplier/bidHomePageBackLog/${supplierCode}`,
        method: 'GET'
    });
};

// 合同数据统计接口
export const getContractInfo = (params) => {
    return request({
        url: `/api-srm-web/contract/contractInfo/countContract`,
        method: 'POST',
        data: params
    });
};

// 投标列表接口
export const bidHomePage = (data) => {
    return request({
        url: `/api-srm-web/bid/bidSupplier/bidHomePage`,
        method: 'POST',
        data
    });
};

// 待签署合同列表接口
export const contractHomePage = (data) => {
    return request({
        url: `/api-srm-web/contract/contractInfo/contractHomePage`,
        method: 'POST',
        data
    });
};

// 招标公告列表接口
export const supplierNoticeHomePage = (data) => {
    return request({
        url: `/api-srm-web/bid/portal/supplierNoticeHomePage`,
        method: 'POST',
        data
    });
};

// 阅读读招标公告时调用
export const addBidNoticeReadLog = (data) => {
    return request({
        url: `/api-srm-web/bid/portal/addBidNoticeReadLog`,
        method: 'POST',
        data
    });
};

// 月度绩效统计接口
export const performanceHomePageCount = (supplierCode) => {
    return request({
        url: `/api-srm-web/supplier/performanceHomePageCount/${supplierCode}`,
        method: 'GET'
    });
};

// 车辆复核不通过数量
export const carReviewRejectCount = (data) => {
    return request({
        url: `/api-srm-web/supplier/supplierCarApprovalRecord/reviewRejectCount`,
        method: 'post',
        data
    });
};

// 司机复核不通过数量
export const driverHomePageCount = (data) => {
    return request({
        url: `/api-srm-web/supplier/supplierDriverApprovalRecord/reviewRejectCount`,
        method: 'post',
        data
    });
};

// 运力待办统计接口
export const supplierDriverHomePageCount = (supplierCode) => {
    return request({
        url: `/api-srm-web/supplier/supplierDriverHomePageCount/${supplierCode}`,
        method: 'GET'
    });
};
// 带申诉仲裁单提醒
export const selectDealTodoCountOrder = data => {
    return request({
        url: `/api-ams/public/ams/abnormal/front/selectDealTodoCountOrder`,
        method: 'post',
        data
    });
};
// 运作待办-待调车
export const getDispatchCreateCount = data => {
    return request({
        url: `/api-tms/indicator/dispatchCreateCount?carrierCode=${data}`,
        method: 'get'
    });
};
// 运作待办-待发车
export const getDispatchLoadedCount = data => {
    return request({
        url: `/api-tms/indicator/dispatchLoadedCount?carrierCode=${data}`,
        method: 'get'
    });
};
// 运作待办-待抵达
export const queryOneTheWayCount = data => {
    return request({
        url: `/api-antms/query/dispatch/queryOneTheWayCount?carrierCode=${data}`,
        method: 'get'
    });
};
// 运作待办-待上传回单
export const queryUnUploadedCount = data => {
    return request({
        url: `/api-antms/query/receipt/queryUnUploadedCount?carrierCode=${data}`,
        method: 'get'
    });
};
// 运力待办-司机运费
export const queryUnconfirmedCount = data => {
    return request({
        url: `/api-antms/query/driverCost/queryUnconfirmedCount?carrierCode=${data}`,
        method: 'get'
    });
};
